import { createMachine } from 'xstate';

export const appMachine = createMachine({
  id: 'empathyCalibration',
  initial: 'booting',
  states: {
    booting: {
      on: { READY: 'consent', FAIL: 'error' }
    },
    consent: {
      on: { VERIFIED: 'idle', FAIL: 'error' }
    },
    idle: {
      on: { PLAY: 'loadingTrial', STATS: 'stats' }
    },
    loadingTrial: {
      on: { TRIAL: 'reading', FAIL: 'error' }
    },
    reading: {
      on: { SUBMIT: 'submitting', STATS: 'stats' }
    },
    submitting: {
      on: { FEEDBACK: 'feedback', FAIL: 'error' }
    },
    feedback: {
      on: { NEXT: 'loadingTrial', STATS: 'stats', RESET: 'idle' }
    },
    stats: {
      on: { PLAY: 'loadingTrial', BACK: 'idle', FAIL: 'error' }
    },
    error: {
      on: { RETRY: 'idle', BOOT: 'booting' }
    }
  }
});
